
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { getDocs, query, where, collection, orderBy, limit } from "firebase/firestore";
import { db } from "../firebase.js";
import { Helmet } from "react-helmet";
import Loadingimg from '../components_root/loadingimg.jsx';
import Loading_items from "../components_root/loading_items.jsx";
import logo_default from "../assets/logo_default.jpg";
import Slideshow_Viewer from "../home_root/slideshow_viewer.js";
import Rating from "../view_root/rating.js";
import { RiShoppingCartLine } from "react-icons/ri";
import { IoIosGitCompare } from "react-icons/io";
import Loading from "../components_root/loading.jsx";
import { CiRead } from "react-icons/ci";
import Saved from "../view_root/saved.js";
import Cookies from "js-cookie";
import { Toast } from "../components_root/ToastContext.jsx";
import Add_cart from "../cart_root/add_cart.js";
import { CiFilter } from "react-icons/ci";
import { MdFilterList } from "react-icons/md";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    description:
        "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords:
        "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png",
};

export default function FilterItems() {
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const location = useLocation();
    const [subcategoryTab, setSubCategoryTab] = useState("");
    const [brandnameTab, setBrandnameTab] = useState("");
    const [IsLoading2, setIsLoading2] = useState(true);
    const [categoryData, setCategoryData] = useState([]);
    const [categoryname, setCategoryname] = useState("");
    const [brandList, setBrandList] = useState([]);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [products_new_data, setProducts_new_data] = useState([]);
    // 🔹 Get category from URL
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const cat = params.get("cat");
        setCategoryname(cat || "");
    }, [location]);

    // 🔹 Fetch products by category
    useEffect(() => {
        if (!categoryname) return; // Wait until categoryname is available

        const fetchCategories = async () => {
            setIsLoading2(true);
            try {
                const q = query(
                    collection(db, "products"),
                    where("status", "==", true),
                    where("category", "==", categoryname)
                );

                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    setCategoryData([]);
                    setBrandList([]);
                    setSubCategoryList([]);
                    return;
                }
                const products = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();
                        let child = {};
                        try {
                            const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                            fieldsSnap.forEach((fieldDoc) => {
                                const { fieldName, fieldValue } = fieldDoc.data();
                                child[fieldName] = fieldValue;
                            });
                        } catch (e) { }
                        return { uid: docSnap.id, ...docData, child };
                    })
                );
                if (!brandnameTab) {
                    setProducts_new_data(products);
                }
                const list = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));


                // ✅ Extract brand and subcategory counts
                const brandMap = new Map();

                list.forEach((item) => {
                    if (item.brandname) {
                        const brand = item.brandname.trim();
                        brandMap.set(brand, (brandMap.get(brand) || 0) + 1);
                    }

                });

                // ✅ Convert Maps to Arrays
                const uniqueBrands = Array.from(brandMap, ([name, totalitems]) => ({
                    name,
                    totalitems,
                }));

                setCategoryData(list);
                setBrandList(uniqueBrands);
            } catch (err) {
                console.error("Error fetching data:", err);
                Toastshow("Error loading data");
            } finally {
                setIsLoading2(false);
            }
        };

        fetchCategories();
    }, [categoryname]);
    useEffect(() => {
        if (!categoryname) return; // Wait until categoryname is available

        const fetchCategories = async () => {
            setIsLoading2(true);
            try {
                const q = query(
                    collection(db, "products"),
                    where("status", "==", true),
                    where("category", "==", categoryname),
                    where("brandname", "==", brandnameTab)
                );

                const snapshot = await getDocs(q);

                if (snapshot.empty) {
                    setSubCategoryList([]);
                    return;
                }
                const products = await Promise.all(
                    snapshot.docs.map(async (docSnap) => {
                        const docData = docSnap.data();
                        let child = {};
                        try {
                            const fieldsSnap = await getDocs(collection(docSnap.ref, "fields"));
                            fieldsSnap.forEach((fieldDoc) => {
                                const { fieldName, fieldValue } = fieldDoc.data();
                                child[fieldName] = fieldValue;
                            });
                        } catch (e) { }
                        return { uid: docSnap.id, ...docData, child };
                    })
                );
                setProducts_new_data(products);
                const list = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));

                // ✅ Extract brand and subcategory counts

                const subCategoryMap = new Map();

                list.forEach((item) => {

                    if (item.subcategory) {
                        const sub = item.subcategory.trim();
                        subCategoryMap.set(sub, (subCategoryMap.get(sub) || 0) + 1);
                    }
                });

                // ✅ Convert Maps to Arrays

                const uniqueSubCategories = Array.from(
                    subCategoryMap,
                    ([name, totalitems]) => ({
                        name,
                        totalitems,
                    })
                );

                setCategoryData(list);
                setSubCategoryList(uniqueSubCategories);
            } catch (err) {
                console.error("Error fetching data:", err);
                Toastshow("Error loading data");
            } finally {
                setIsLoading2(false);
            }
        };

        fetchCategories();
    }, [categoryname, brandnameTab]);
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("subcat");
        if (tab) setSubCategoryTab(tab.toLowerCase());
    }, []);
    const setSubcatTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("subcat", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", "" + newUrl);
    };
    //brandname
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const tab = params.get("brand");
        if (tab) setBrandnameTabInUrl(tab.toLowerCase());
    }, []);
    const setBrandnameTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("brand", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", "" + newUrl);
    };


    return (
        <div>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">

                <div className="post-container">
                    <div className="post_updates">
                        <div className="fcap bold text-h1 p-2">{categoryname}</div>

                        <table className="items-back-fill">
                            <tr>
                                <td><div className="fcap text-h2 p-11 ">Brands</div></td>
                                <td width={22}><CiFilter className="icon" /></td>
                            </tr>
                        </table>

                        <div className="p-1">
                            {brandList.map((b, i) => (
                                <div className={`ui-items cursor ${brandnameTab === b.name ? "blue bold" : ""}`}

                                    key={i}
                                    onClick={() => {
                                        setBrandnameTab(b.name);
                                        setBrandnameTabInUrl(b.name);
                                    }}
                                >
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td className="text-h2 fcap ">{b.name}</td>
                                                <td width={30} className="text-off text-r text-h2">
                                                    {b.totalitems}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            ))}
                        </div>

                        <table className="items-back-fill">
                            <tr>
                                <td><div className="fcap text-h2 p-11 ">Subcategory</div></td>
                                <td width={22}><MdFilterList className="icon" /></td>
                            </tr>
                        </table>
                        <div className="p-1">
                            <div className="ui-grid-fill">
                                {subCategoryList.map((s, i) => (
                                    <div className={`ui-items cursor ${subcategoryTab === s.name ? "blue bold" : ""}`}

                                        key={i}
                                        onClick={() => {
                                            setSubCategoryTab(s.name);
                                            setSubcatTabInUrl(s.name);
                                        }}
                                    >
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td className="text-h2  fcap">{s.name.trim()}</td>
                                                    <td width={30} className="text-off text-r text-h2">{s.totalitems}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                ))}
                            </div>

                        </div>
                    </div>

                    <div className="post_div p-1 m-top-10">
                        <div className="ui-grid-home-items">
                            {IsLoading2 ? (
                                <></>
                            ) : products_new_data.length === 0 ? (
                                <div></div>
                            ) : (
                                products_new_data.map((row) => (
                                    <div className="ui-items items-back hover rounded cursor shadow" key={row.uid}>
                                        <div className="w-back-30" style={{ position: "absolute", top: 0, left: 0, right: 0, zIndex: 2 }}>
                                            <table>
                                                <tr>
                                                    <td>
                                                        <div className="text-shadow-w text-h2 p-22 fcap bold">{row.brandname}</div>
                                                    </td>
                                                    <td width={30}>

                                                        {row.child?.dealname != null && (
                                                            <div className="text-h3 red-back white p-1 rounded">-
                                                                {row.child
                                                                    ? `${Math.round(
                                                                        ((row.child?.mrp - row.child?.price) /
                                                                            row.child?.mrp) *
                                                                        100
                                                                    )}%`
                                                                    : ""}
                                                            </div>
                                                        )}

                                                    </td>
                                                </tr>
                                            </table>


                                        </div>
                                        <div style={{ position: "relative" }}>
                                            <div className="w-back-30" style={{ position: "absolute", bottom: 0, left: 0, right: 0, zIndex: 2 }}>
                                                <table>
                                                    <tr>
                                                        <td width={22}>{<Saved product={row.uid} />}</td>
                                                        <td width={85}> <Rating productId={row.uid} /></td>
                                                    </tr>
                                                </table>

                                            </div>
                                            <img
                                                className="ads-items-default"
                                                alt={row.title}
                                                onClick={() => row.slug && navigate("/" + row.slug)}
                                                src={row.thumbnail || logo_default}
                                                onError={(e) => {
                                                    e.target.onerror = null; // Prevent infinite loop if logo_default also fails
                                                    e.target.src = logo_default;
                                                }}
                                            />


                                        </div>
                                        <div className="p-1">
                                            <div className="text-h2 fcap m-b">{row.title?.substring(0, 35)}...</div>
                                            {row.child?.dealname && (
                                                <div><span className="red text-h3 items-back rounded-sm">{row.child.dealname}</span></div>
                                            )}
                                        </div>
                                        <table className="table-fixed">
                                            <tr>
                                                <td >

                                                    <div className="flex">
                                                        <span className="text-off text-h2">₹</span>
                                                        <div className="text-h1 bold">{row.child?.price || ""}</div>
                                                        <span className="text-off text-h2">/-</span>
                                                    </div>
                                                </td>



                                                <td  >
                                                    {row.child?.mrp > 0 && row.child?.mrp != null && (
                                                        <div className=" text-h2 text-off"><span className="text-off ">₹</span><a className="th-line">{row.child?.mrp}</a>/-</div>
                                                    )}
                                                </td>
                                            </tr>
                                        </table>
                                        {/* <div onClick={() => navigate("/compare/?slug=" + row.slug + "&uid=" + row.uid + "&cat=" + row.category + "&scat=" + row.subcategory)} className="button-ui3 fill p-1 cursor"><IoIosGitCompare className="icon" /> Compare</div>  */}

                                        <div className="m-top-5 ">
                                            <table className="table-fixed">
                                                <tr>


                                                    <td width={40} >
                                                        <div title="Compare" className="button-ui2 fill cursor "
                                                            onClick={() => navigate("/compare/?slug=" + row.slug + "&uid=" + row.uid + "&cat=" + row.category + "&scat=" + row.subcategory)}
                                                        ><IoIosGitCompare className="icon" /> {row.compare} </div>
                                                    </td>

                                                    <td width={30}  >
                                                        <Add_cart product={row.uid} />
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
}
